<template>
  <div class="container" id="footer">
    <div class="row d-flex align-items-center">
        <div class="footer-box">
            <p>If you like my work. You can find me here.</p>
        </div>
        <div class="footer-box">
            <div class="footer-box-middle">
                <div class="social-media">
                    <div class="social-media-box">
                        <a class="icon-decoration" href="https://www.instagram.com/smileydoodle/" target="_blank"><i class="fab fa-instagram fa-2x mobile"></i></a>
                        <a class="icon-decoration" href="https://www.behance.net/smileydoodle" target="_blank"><i class="fab fa-behance fa-2x mobile"></i></a>
                    </div>
                    <div class="social-media-box">
                        <p>/ smileydoodle</p>
                    </div>
                </div>
                <div class="social-media">
                    <div class="social-media-box">
                        <a class="icon-decoration" href="https://www.linkedin.com/in/annaskrtv/" target="_blank"><i class="fab fa-linkedin fa-2x mobile"></i></a>
                        <a class="icon-decoration" href="https://www.pinterest.com/annaskrtv" target="_blank"><i class="fab fa-pinterest-square fa-2x mobile"></i></a>
                    </div>
                    <div class="social-media-box">
                        <p>/ annaskrtv</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-box-bottom">
            <p>© {{ new Date().getFullYear() }} - All Rights Reserved</p>
        </div>
    </div>      
  </div>
</template>



<script>
export default {
  name: 'Footer'
}
</script>



<style>
#footer {
    padding: 60px 0;
}
.footer-box {
    position: relative;
    display: inline-block;
    width: 30%;
    margin: 0 auto;
}
.footer-box-middle {
    position: relative;
    display: inline-block;
    width: 70%;
    text-align: left;
}
.footer-box-bottom {
    position: relative;
    display: inline-block;
    width: 25%;
    margin: 0 auto;
    text-align: right;
}
.social-media {
    position: relative;
    display: inline-block;
    width: 90%;
}
.social-media-box {
    position: relative;
    display: inline-block;
}
.icon-decoration {
    color: #085561;
}
.icon-decoration:hover {
    color: #F3A822 ;
    transition: all 0.5s ease-in;
    cursor: pointer; 
}
.fa-instagram {
    margin-right: 1.5rem;
}
.fa-linkedin {
    margin-right: 1.5rem;
}
.fa-behance {
    margin-right: 0.5rem;
}
.fa-pinterest-square {
    margin-right: 0.5rem;
}

@media only screen 
and (min-device-width : 768px) and (max-device-width : 1024px) {
.footer-box {
    font-size: 0.8rem;
    width: 33%;
}
.footer-box-middle {
    width: 80%;
}
.footer-box-bottom {
    font-size: 0.8rem;
}
.mobile {
    margin-right: 0.5rem;
}
}
@media only screen and (max-width: 600px) {
#footer {
    padding: 30px 0;
}
.footer-box {
    width: 75%;
    font-size: 0.7rem;
}
.footer-box-bottom {
    width: 75%;
    font-size: 0.7rem;
    text-align: center;
}
.footer-box-middle {
    text-align: center;
}
.mobile {
    margin-right: 0.5rem;
}
}
</style>